import { useMemo } from "react";
import ImageWmsLayer from "@avinet/adaptive-ui-maps/layer/ImageWmsLayer";
import OsmLayer from "@avinet/adaptive-ui-maps/layer/OsmLayer";
import TileWmsLayer from "@avinet/adaptive-ui-maps/layer/TileWmsLayer";
import WmtsLayer from "@avinet/adaptive-ui-maps/layer/WmtsLayer";
import useAdaptiveTheme from "../../hooks/useAdaptiveTheme";
import { Theme } from "../../types/Theme";

export const AdaptiveLayerLoader = ({
  themeUuid,
  themeType,
}: {
  themeUuid: string;
  themeType: "theme" | "digitheme" | "basetheme";
}) => {
  const { theme } = useAdaptiveTheme(
    themeType === "basetheme" ? "baselayer" : "layer",
    themeUuid
  );

  if (!theme) return null;

  return <AdaptiveLayer theme={theme} />;
};

const AdaptiveLayer = ({ theme }: { theme: Theme }) => {
  const urls = useMemo(() => theme.url?.split("|") ?? [], [theme.url]);
  const url = useMemo(() => urls[0], [urls]);

  const useBaat = useMemo(
    () => theme.url?.indexOf("BaatGatekeeper") !== -1 ?? false,
    [theme]
  );

  const params = useMemo(() => {
    const params: any = {};
    if (theme.proxy_type === "mapserver") {
      params.gui = theme.gui_id;
    }
    return params;
  }, [theme.gui_id, theme.proxy_type]);

  switch (theme.layer_type) {
    case "WMS":
      if (theme.single_tile || theme.is_internal)
        return (
          <ImageWmsLayer
            layers={theme.layers}
            url={url}
            version={theme.version}
            params={params}
            authKey={useBaat ? "GKT" : undefined}
          />
        );
      return (
        <TileWmsLayer
          layers={theme.layers}
          url={url}
          version={theme.version}
          params={params}
          authKey={useBaat ? "GKT" : undefined}
        />
      );

    case "WMTS":
      return (
        <WmtsLayer
          layer={theme.layers}
          style={theme.style ?? "default"}
          matrixSet={theme.matrix_set ?? ""}
          url={url}
          authKey={useBaat ? "GKT" : undefined}
        />
      );

    case "OSM":
      return <OsmLayer />;

    default:
      console.error("Unsupported layer type: " + theme.layer_type);
      return null;
  }
};

export default AdaptiveLayer;
